(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sct-mobile-cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    const drawer = document.getElementById('sct-mobile-cart');
    if (!drawer || drawer.dataset.initialized || typeof drawer.showModal !== 'function') return;
    drawer.dataset.initialized = 'true';
    const mobile = window.matchMedia('(max-width: 798px)');
    const isMobile = () => mobile.matches || new URLSearchParams(location.search).get('sct_cart_test') === '1';
    const body = drawer.querySelector('.sct-mobile-cart__body');
    let content, placeholder, opener, opening = false;
    const containers = () => Array.from(document.querySelectorAll('.cart_container'));
    function enhance() {
      drawer.querySelectorAll('.js-change-quantity').forEach(control => {
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-label', control.dataset.func === 'minus' ? drawer.dataset.decreaseLabel : drawer.dataset.increaseLabel);
      });
      drawer.querySelectorAll('input.quantity').forEach(input => input.setAttribute('aria-label', drawer.dataset.quantityLabel));
      drawer.querySelectorAll('.cart__remove-btn').forEach(control => control.setAttribute('aria-label', drawer.dataset.removeLabel));
    }
    function close() {
      if (drawer.open) drawer.close();
    }
    function open(trigger) {
      if (!isMobile() || drawer.open || opening) return;
      content = document.querySelector('.cart_content');
      if (!content) return;
      opening = true;
      opener = trigger || document.querySelector('#header .mini_cart');
      placeholder = document.createElement('span');
      placeholder.hidden = true;
      content.before(placeholder);
      body.append(content);
      document.body.classList.remove('blocked-scroll');
      document.body.classList.add('sct-cart-open');
      try {
        drawer.showModal();
        enhance();
        drawer.querySelector('.sct-mobile-cart__close').focus();
      } catch (error) {
        placeholder.replaceWith(content);
        document.body.classList.remove('sct-cart-open');
      }
      opening = false;
    }
    document.addEventListener('click', event => {
      const trigger = event.target.closest('.mini_cart');
      if (trigger && isMobile() && document.querySelector('.cart_content')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        open(trigger);
      }
      if (drawer.open && event.target.closest('.cart_content__continue-shopping')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        close();
      }
    }, true);
    drawer.querySelector('.sct-mobile-cart__close').addEventListener('click', close);
    drawer.addEventListener('click', event => {
      if (event.target !== drawer) return;
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    drawer.addEventListener('keydown', event => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.js-change-quantity')) {
        event.preventDefault();
        event.target.click();
      }
    });
    drawer.addEventListener('close', () => {
      if (placeholder && content) placeholder.replaceWith(content);
      containers().forEach(container => container.classList.remove('active_link'));
      document.body.classList.remove('blocked-scroll');
      document.body.classList.remove('sct-cart-open');
      if (opener && opener.isConnected) opener.focus();
    });
    const observer = new MutationObserver(records => {
      if (!isMobile() || drawer.open || opening) return;
      if (records.some(record => record.target.classList.contains('active_link'))) open();
    });
    containers().forEach(container => observer.observe(container, {attributes:true, attributeFilter:['class']}));
    new MutationObserver(() => {
      if (drawer.open && document.body.classList.contains('blocked-scroll')) {
        document.body.classList.remove('blocked-scroll');
      }
    }).observe(document.body, {attributes:true,attributeFilter:['class']});
    const count = document.querySelector('.top_bar .cart_count') || document.querySelector('#header .cart_count');
    if (count) {
      let previousCount = Number(count.textContent) || 0;
      new MutationObserver(() => {
        const nextCount = Number(count.textContent) || 0;
        if (nextCount > previousCount && isMobile() && !drawer.open) open();
        previousCount = nextCount;
      }).observe(count, {childList:true,characterData:true,subtree:true});
    }
    new MutationObserver(enhance).observe(body, {childList:true, subtree:true});
    mobile.addEventListener('change', () => { if (!isMobile()) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sct-shipping-progress"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    const panel = document.getElementById('sct-shipping-progress');
    const drawer = document.getElementById('sct-mobile-cart');
    if (!panel || !drawer || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    let timer, revision = 0;
    async function refresh() {
      const current = ++revision;
      panel.hidden = true;
      if (!drawer.open || panel.dataset.country !== 'US') return;
      try {
        const response = await fetch(panel.dataset.cartUrl, {credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) return;
        const cart = await response.json();
        if (current !== revision || !drawer.open || cart.currency !== 'USD' || !cart.items.some(item => item.requires_shipping) || cart.total_price > Number(panel.dataset.maximum)) return;
        const threshold = Number(panel.dataset.threshold);
        const remaining = Math.max(0, threshold - cart.total_price);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:'USD'}).format(remaining / 100);
        panel.querySelector('[data-sct-shipping-message]').textContent = remaining ? panel.dataset.remaining.replace('[amount]', money) : panel.dataset.reached;
        panel.querySelector('progress').value = Math.min(threshold,cart.total_price);
        panel.hidden = false;
      } catch (error) { panel.hidden = true; }
    }
    function schedule() { ++revision; panel.hidden = true; clearTimeout(timer); if (drawer.open) timer = setTimeout(refresh, 180); }
    new MutationObserver(schedule).observe(drawer.querySelector('.sct-mobile-cart__body'), {subtree:true,childList:true,characterData:true});
    new MutationObserver(schedule).observe(drawer, {attributes:true,attributeFilter:['open']});
    drawer.addEventListener('close', () => { ++revision; clearTimeout(timer); panel.hidden = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sct-size-shortcuts"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    const shortcuts = document.getElementById('sct-size-shortcuts');
    const tree = document.getElementById('bc-sf-filter-tree');
    if (!shortcuts || !tree || shortcuts.dataset.initialized) return;
    shortcuts.dataset.initialized = 'true';
    if (new URLSearchParams(location.search).get('sct_cart_test') === '1') shortcuts.dataset.test = 'true';
    const values = shortcuts.querySelector('.sct-size-shortcuts__values');
    function anchors() { return Array.from(tree.querySelectorAll('a[data-id="pf_opt_size"][data-value]')); }
    function sync() {
      const links = anchors();
      shortcuts.hidden = !links.length;
      const keys = links.map(a => a.dataset.value);
      if (JSON.stringify(keys) !== values.dataset.keys) {
        const focused = document.activeElement && document.activeElement.dataset.sctSize;
        values.replaceChildren(...links.map(link => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.sctSize = link.dataset.value;
          button.textContent = link.dataset.title;
          return button;
        }));
        values.dataset.keys = JSON.stringify(keys);
        if (focused) Array.from(values.children).find(b => b.dataset.sctSize === focused)?.focus({preventScroll:true});
      }
      Array.from(values.children).forEach(button => {
        const link = links.find(a => a.dataset.value === button.dataset.sctSize);
        button.setAttribute('aria-pressed', String(link.classList.contains('selected')));
        button.disabled = link.dataset.count === '0' && !link.classList.contains('selected');
      });
    }
    values.addEventListener('click', event => {
      const button = event.target.closest('button[data-sct-size]');
      if (!button || button.disabled) return;
      const link = anchors().find(a => a.dataset.value === button.dataset.sctSize);
      if (link) link.click();
    });
    new MutationObserver(sync).observe(tree, {subtree:true,childList:true,attributes:true,attributeFilter:['class','data-count']});
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sct-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    const bar = document.getElementById('sct-sticky-purchase');
    if (!bar || bar.dataset.initialized) return;
    const section = document.querySelector('.product-template .js-product_section');
    const wrapper = section && section.querySelector('[data-product-form]');
    const form = wrapper && wrapper.querySelector('form');
    const native = form && form.querySelector('.add_to_cart');
    if (!native || wrapper.dataset.productId !== bar.dataset.productId) return;
    bar.dataset.initialized = 'true';
    const test = new URLSearchParams(location.search).get('sct_cart_test') === '1';
    if (test) bar.dataset.test = 'true';
    const media = matchMedia('(max-width:798px)');
    const anchor = document.createElement('span');
    anchor.style.display = 'block';
    anchor.style.height = '0px';
    native.before(anchor);
    const originalHeight = native.offsetHeight;
    const label = bar.querySelector('[data-sct-variant]');
    let product;
    try { product = JSON.parse(wrapper.dataset.product); } catch (error) { return; }
    function sync() {
      const input = form.querySelector('[name="id"]');
      const variant = product.variants.find(v => String(v.id) === String(input && input.value));

      const price = section.querySelector('.current_price');
      label.textContent = [variant && variant.title !== 'Default Title' ? variant.title : '', price ? price.textContent.trim() : ''].filter(Boolean).join(' · ');
      const visible = (media.matches || test) && anchor.getBoundingClientRect().top + originalHeight < 0;
      bar.hidden = !visible;
      native.classList.toggle('sct-sticky-native', visible);
      anchor.style.height = visible ? originalHeight + 'px' : '0px';
      document.body.style.paddingBottom = visible ? bar.offsetHeight + 'px' : originalPadding;
    }
    const originalPadding = document.body.style.paddingBottom;
    let queued = false;
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; sync(); }); } }
    bar.querySelector('[data-sct-options]').addEventListener('click', () => {
      wrapper.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      const option = form.querySelector('.swatch input:not(:disabled), select:not([style*="display: none"]), .add_to_cart');
      if (option) option.focus({preventScroll:true});
    });
    section.addEventListener('change', schedule);
    section.addEventListener('click', () => { schedule(); setTimeout(schedule, 100); });
    new MutationObserver(schedule).observe(section, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class','value']});
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    media.addEventListener('change', schedule);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
